export enum WorkflowStatusEnum {
  Waiting = 1,
  Processing = 2,
  Finished = 3,
  Canceled = 4
}
